import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../../components/SectionHeading";
import { homeIcons } from "../Home/homeIcons";
import { philosophyContent as supportContent } from "./teamContent";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

/* "Our Consulting Philosophy". The four stages are numbered because the
   document presents them as a sequence; the numerals are ordinals of that
   list, not added claims. */
const TeamSupport = () => (
  <section
    className="bg-white py-14 lg:py-20"
    aria-labelledby="team-support-heading"
  >
    <div className="brand-col">
      <SectionHeading
        id="team-support-heading"
        title={supportContent.title}
        subtitle={supportContent.subtitle}
      />
      {supportContent.lead && (
        <p className="mx-auto -mt-4 max-w-3xl text-center text-sm md:text-base leading-relaxed text-gray-600">
          {supportContent.lead}
        </p>
      )}
      <p
        className={`mx-auto mb-10 max-w-3xl text-center text-sm md:text-base font-semibold text-gray-900 ${
          supportContent.lead ? "mt-3" : "-mt-4"
        }`}
      >
        {supportContent.intro}
      </p>
      <motion.ol
        className="grid list-none grid-cols-1 gap-6 p-0 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
      >
        {supportContent.stages.map((stage, i) => {
          const Icon = homeIcons[stage.icon];
          return (
            <motion.li
              key={stage.title}
              variants={cardVariants}
              className="brand-card p-6 lg:p-8"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--brand-primary)] text-white shadow-md">
                  <Icon aria-hidden="true" className="h-5 w-5" />
                </span>
                <span
                  className="text-3xl font-extrabold text-[rgba(104,46,146,0.2)]"
                  aria-hidden="true"
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-5 text-lg font-bold text-gray-900">
                {stage.title}
              </h3>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-gray-600">
                {stage.description}
              </p>
            </motion.li>
          );
        })}
      </motion.ol>
    </div>
  </section>
);

export default TeamSupport;
